import DatePicker, {ReactDatePickerProps, registerLocale, setDefaultLocale} from "react-datepicker";
import classNames from "classnames";
import {pl} from "date-fns/locale/pl";

import "react-datepicker/dist/react-datepicker.css";
import {clearBtn, datepickerCalendarStyle, datepickerStyle, errorStateStyle, wrapperStyle} from "./Datepicker.module.css";

export type DatepickerProps = ReactDatePickerProps & {
    //all props: https://github.com/Hacker0x01/react-datepicker/blob/main/docs/datepicker.md
    className?: string;
    error?: boolean;
};

registerLocale("pl", pl);
setDefaultLocale("pl");

export const Datepicker = ({
    className,
    dateFormat = "dd/MM/yyyy",
    placeholderText = "Proszę wybrać datę...",
    isClearable = true,
    error,
    ...datepickerProps
}: DatepickerProps) => {
    const datepickerCN = classNames(datepickerStyle, error ? errorStateStyle : {});

    return (
        <div className={wrapperStyle}>
            <DatePicker
                placeholderText={placeholderText}
                className={datepickerCN}
                dateFormat={dateFormat}
                isClearable={isClearable}
                clearButtonClassName={clearBtn}
                calendarClassName={datepickerCalendarStyle}
                wrapperClassName={className}
                calendarStartDay={1}
                {...datepickerProps}
            />
        </div>
    );
};
import DatePicker, {ReactDatePickerProps, registerLocale, setDefaultLocale} from "react-datepicker";
import classNames from "classnames";
import {pl} from "date-fns/locale/pl";

import "react-datepicker/dist/react-datepicker.css";
import {clearBtn, datepickerCalendarStyle, datepickerStyle, errorStateStyle, wrapperStyle} from "./Datepicker.module.css";

export type DatepickerProps = ReactDatePickerProps & {
    //all props: https://github.com/Hacker0x01/react-datepicker/blob/main/docs/datepicker.md
    className?: string;
    error?: boolean;
};

registerLocale("pl", pl);
setDefaultLocale("pl");

export const Datepicker = ({
    className,
    dateFormat = "dd/MM/yyyy",
    placeholderText = "Proszę wybrać datę...",
    isClearable = true,
    error,
    ...datepickerProps
}: DatepickerProps) => {
    const datepickerCN = classNames(datepickerStyle, error ? errorStateStyle : {});

    return (
        <div className={wrapperStyle}>
            <DatePicker
                placeholderText={placeholderText}
                className={datepickerCN}
                dateFormat={dateFormat}
                isClearable={isClearable}
                clearButtonClassName={clearBtn}
                calendarClassName={datepickerCalendarStyle}
                wrapperClassName={className}
                calendarStartDay={1}
                {...datepickerProps}
            />
        </div>
    );
};
